import { Box, Flex, Image, Stack, Text } from "@chakra-ui/react";

import ModalForm from "@/components/referidos/ModalForm";

const Banner = (props) => {
    return (
        <Box w="full" mx="auto" maxW="full" {...props} paddingInline="0">
            <Flex
                w="100%"
                h="85vh"
                id="fondo"
                backgroundImage="url(https://media.grupoguia.mx/assets/guiaconnect/banner/guiaconnect_banner.webp)"
                backgroundSize="cover"
                backgroundPosition="center center"
                backgroundRepeat="no-repeat"
                position="relative"
                p="0"
                bgColor="gray.100"
                borderRadius="10px"
            >
                <Flex
                    direction="column"
                    w="100%"
                    position="absolute"
                    left="0"
                    top="35%"
                    px={{ base: 4, md: 0 }}
                    textAlign="center"
                >
                    <Flex w="100%" justifyContent="center">
                        <Image
                            src="https://media.grupoguia.mx/assets/home-page/logos/logo-guia-conect-bco.webp"
                            width={{ base: "200", md: "336" }}
                            height="119"
                            alt="guiaconectlogo"
                        />
                    </Flex>
                    <Text
                        fontSize={{ base: "xl", md: '"3xl"' }}
                        align="center"
                        mt={4}
                        color="white"
                        fontWeight="normal"
                    >
                        <strong>¡Únete a Guia Connect y accede a bonos exclusivos!</strong>
                    </Text>
                    <Text
                        fontSize={{ base: "lg", md: "2xl" }}
                        align="center"
                        mb="8"
                        color="white"
                        fontWeight="normal"
                    >
                        Si has realizado alguna compra o venta en Grupo Guía, ¡regístrate y comienza
                        a referir!
                    </Text>
                    <Stack
                        direction={{ base: "column", md: "row" }}
                        w="full"
                        maxW="6xl"
                        mx="auto"
                        align="center"
                        transitionDuration=".3s"
                        justifyContent="center"
                        mt={10}
                    >
                        <ModalForm
                            name="Regístrate y refiere"
                            type="Datos del Referidor"
                            optionsDevelops={props.optionsDevelops}
                        />
                    </Stack>
                    <Text
                        fontSize={{ base: "lg", md: "2xl" }}
                        align="center"
                        mb="8"
                        color="white"
                        fontWeight="normal"
                        mt={10}
                    >
                        Tu lealtad merece <strong>ser recompensada</strong>
                    </Text>
                </Flex>
            </Flex>
        </Box>
    );
};

export default Banner;
